import { ComponentProps } from '@stitches/react'
import { useHandlePayment } from 'hooks/useHandlePayment'
import { useStore } from 'lib/store'
import { theme } from 'lib/theme'
import { observer } from 'mobx-react-lite'
import { Post } from 'models/Post'
import { Box } from 'primitives/Box'
import { forwardRef } from 'react'
import { PostAssetsCarousel } from 'shared/PostAssetsCarousel/PostAssetsCarousel'
import { PostBottomBar } from './components/BottomBar'
import { PostCaption } from './components/PostCaption'
import { PostTopBar } from './components/TopBar'

interface Props extends ComponentProps<typeof Box> {
  post: Post
  showTopMenu?: boolean
  descMaxLines?: number
}

const _PostCard = forwardRef<HTMLDivElement, Props>(({ css, post, showTopMenu = true }, ref) => {
  const store = useStore()

  const { handlePayment } = useHandlePayment({ post })

  const handleAssetClick = () => {
    store.feed.setSelectedPost(post)
    store.ui.openPostModal()
  }

  return (
    <Box
      ref={ref}
      css={{
        backgroundColor: theme.colors.gray300,
        borderRadius: '6px',
        ...css
      }}
    >
      <PostTopBar
        post={post}
        css={{
          display: showTopMenu ? 'flex' : 'none'
        }}
      />
      <PostCaption post={post} />
      <PostAssetsCarousel post={post} onClick={handleAssetClick} />
      <PostBottomBar post={post} handlePayment={handlePayment} />
    </Box>
  )
})

_PostCard.displayName = 'PostCard'

export const PostCard = observer(_PostCard)
